import api from "./apiClient.js";

const endpoint = "user";

export const getAllUsers = () => {
	return api.get(endpoint);
};

export const updateUser = (id, email, level, office) => {
	return api.put(endpoint + "/" + id, { email, level, office });
};

export const deleteUser = (id) => {
	return api.delete(endpoint + "/" + id);
};

export const deleteAllSessions = (userId) => {
	return api.delete(endpoint + "/" + userId + "/sessions");
};
